// @ts-nocheck
/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { graphql, type GraphQLResponseResolver, type RequestHandlerOptions } from 'msw'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  DateTime: { input: any; output: any; }
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  Dimension: { input: any; output: any; }
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  HexColor: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  Quality: { input: any; output: any; }
};

/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBc = Entry & _Node & {
  __typename?: 'AppointmentBookingBc';
  _id: Scalars['ID']['output'];
  bcHeadlineCalendar?: Maybe<Scalars['String']['output']>;
  bcHeadlineConsultationChannel?: Maybe<Scalars['String']['output']>;
  bcHeadlineRequest?: Maybe<Scalars['String']['output']>;
  bcHeadlineTimepicker?: Maybe<Scalars['String']['output']>;
  bcIntro?: Maybe<Scalars['String']['output']>;
  bcSupTitle?: Maybe<Scalars['String']['output']>;
  bcTitle?: Maybe<Scalars['String']['output']>;
  confirmationClosing?: Maybe<Scalars['String']['output']>;
  confirmationSubtitle?: Maybe<Scalars['String']['output']>;
  confirmationText?: Maybe<Scalars['String']['output']>;
  confirmationText2?: Maybe<Scalars['String']['output']>;
  confirmationTitle?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  formValidationErrorPhone?: Maybe<Scalars['String']['output']>;
  formValidationErrorSpaces?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<AppointmentBookingBcLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  opportunityTypeOffice?: Maybe<Scalars['String']['output']>;
  opportunityTypePhone?: Maybe<Scalars['String']['output']>;
  opportunityTypeTeams?: Maybe<Scalars['String']['output']>;
  progressBarItemTitleStepOne?: Maybe<Scalars['String']['output']>;
  progressBarItemTitleStepThree?: Maybe<Scalars['String']['output']>;
  progressBarItemTitleStepTwo?: Maybe<Scalars['String']['output']>;
  requestAppointment?: Maybe<Scalars['String']['output']>;
  requestDataProtectionLink?: Maybe<Scalars['String']['output']>;
  requestDescription?: Maybe<Scalars['String']['output']>;
  requestDescriptionLabel?: Maybe<Scalars['String']['output']>;
  requestEMail?: Maybe<Scalars['String']['output']>;
  requestFirstName?: Maybe<Scalars['String']['output']>;
  requestGenderFemale?: Maybe<Scalars['String']['output']>;
  requestGenderMale?: Maybe<Scalars['String']['output']>;
  requestGenderOther?: Maybe<Scalars['String']['output']>;
  requestLastName?: Maybe<Scalars['String']['output']>;
  requestMethodEmail?: Maybe<Scalars['String']['output']>;
  requestMethodOfContactLabel?: Maybe<Scalars['String']['output']>;
  requestMethodPhone?: Maybe<Scalars['String']['output']>;
  requestOpportunityCostConfirmation?: Maybe<Scalars['String']['output']>;
  requestPhone?: Maybe<Scalars['String']['output']>;
  requestSalutation?: Maybe<Scalars['String']['output']>;
  saleSiteSelectPlaceholder?: Maybe<Scalars['String']['output']>;
  select?: Maybe<Scalars['String']['output']>;
  submitButton?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcBcHeadlineCalendarArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcBcHeadlineConsultationChannelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcBcHeadlineRequestArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcBcHeadlineTimepickerArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcBcIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcBcSupTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcBcTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcConfirmationClosingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcConfirmationSubtitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcConfirmationTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcConfirmationText2Args = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcConfirmationTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcFormValidationErrorPhoneArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcFormValidationErrorSpacesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcOpportunityTypeOfficeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcOpportunityTypePhoneArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcOpportunityTypeTeamsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcProgressBarItemTitleStepOneArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcProgressBarItemTitleStepThreeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcProgressBarItemTitleStepTwoArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestAppointmentArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestDataProtectionLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestDescriptionLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestEMailArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestFirstNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestGenderFemaleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestGenderMaleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestGenderOtherArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestLastNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestMethodEmailArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestMethodOfContactLabelArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestMethodPhoneArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestOpportunityCostConfirmationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestPhoneArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcRequestSalutationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcSaleSiteSelectPlaceholderArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcSelectArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/appointmentBookingBC) */
export type AppointmentBookingBcSubmitButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AppointmentBookingBcCollection = {
  __typename?: 'AppointmentBookingBcCollection';
  items: Array<Maybe<AppointmentBookingBc>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AppointmentBookingBcFilter = {
  AND?: InputMaybe<Array<InputMaybe<AppointmentBookingBcFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AppointmentBookingBcFilter>>>;
  bcHeadlineCalendar?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineCalendar_contains?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineCalendar_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bcHeadlineCalendar_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcHeadlineCalendar_not?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineCalendar_not_contains?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineCalendar_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcHeadlineConsultationChannel?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineConsultationChannel_contains?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineConsultationChannel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bcHeadlineConsultationChannel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcHeadlineConsultationChannel_not?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineConsultationChannel_not_contains?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineConsultationChannel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcHeadlineRequest?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineRequest_contains?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineRequest_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bcHeadlineRequest_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcHeadlineRequest_not?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineRequest_not_contains?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineRequest_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcHeadlineTimepicker?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineTimepicker_contains?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineTimepicker_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bcHeadlineTimepicker_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcHeadlineTimepicker_not?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineTimepicker_not_contains?: InputMaybe<Scalars['String']['input']>;
  bcHeadlineTimepicker_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcIntro?: InputMaybe<Scalars['String']['input']>;
  bcIntro_contains?: InputMaybe<Scalars['String']['input']>;
  bcIntro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bcIntro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcIntro_not?: InputMaybe<Scalars['String']['input']>;
  bcIntro_not_contains?: InputMaybe<Scalars['String']['input']>;
  bcIntro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcSupTitle?: InputMaybe<Scalars['String']['input']>;
  bcSupTitle_contains?: InputMaybe<Scalars['String']['input']>;
  bcSupTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bcSupTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcSupTitle_not?: InputMaybe<Scalars['String']['input']>;
  bcSupTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  bcSupTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcTitle?: InputMaybe<Scalars['String']['input']>;
  bcTitle_contains?: InputMaybe<Scalars['String']['input']>;
  bcTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  bcTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bcTitle_not?: InputMaybe<Scalars['String']['input']>;
  bcTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  bcTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationClosing?: InputMaybe<Scalars['String']['input']>;
  confirmationClosing_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationClosing_exists?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationClosing_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationClosing_not?: InputMaybe<Scalars['String']['input']>;
  confirmationClosing_not_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationClosing_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationSubtitle?: InputMaybe<Scalars['String']['input']>;
  confirmationSubtitle_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationSubtitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationSubtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationSubtitle_not?: InputMaybe<Scalars['String']['input']>;
  confirmationSubtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationSubtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  confirmationText2?: InputMaybe<Scalars['String']['input']>;
  confirmationText2_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationText2_exists?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationText2_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationText2_not?: InputMaybe<Scalars['String']['input']>;
  confirmationText2_not_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationText2_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationText_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationText_not?: InputMaybe<Scalars['String']['input']>;
  confirmationText_not_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationTitle?: InputMaybe<Scalars['String']['input']>;
  confirmationTitle_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationTitle_not?: InputMaybe<Scalars['String']['input']>;
  confirmationTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  formValidationErrorPhone?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorPhone_contains?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorPhone_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formValidationErrorPhone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formValidationErrorPhone_not?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorPhone_not_contains?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorPhone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formValidationErrorSpaces?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorSpaces_contains?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorSpaces_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formValidationErrorSpaces_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formValidationErrorSpaces_not?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorSpaces_not_contains?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorSpaces_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityTypeOffice?: InputMaybe<Scalars['String']['input']>;
  opportunityTypeOffice_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityTypeOffice_exists?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityTypeOffice_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityTypeOffice_not?: InputMaybe<Scalars['String']['input']>;
  opportunityTypeOffice_not_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityTypeOffice_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityTypePhone?: InputMaybe<Scalars['String']['input']>;
  opportunityTypePhone_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityTypePhone_exists?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityTypePhone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityTypePhone_not?: InputMaybe<Scalars['String']['input']>;
  opportunityTypePhone_not_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityTypePhone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityTypeTeams?: InputMaybe<Scalars['String']['input']>;
  opportunityTypeTeams_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityTypeTeams_exists?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityTypeTeams_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityTypeTeams_not?: InputMaybe<Scalars['String']['input']>;
  opportunityTypeTeams_not_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityTypeTeams_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  progressBarItemTitleStepOne?: InputMaybe<Scalars['String']['input']>;
  progressBarItemTitleStepOne_contains?: InputMaybe<Scalars['String']['input']>;
  progressBarItemTitleStepOne_exists?: InputMaybe<Scalars['Boolean']['input']>;
  progressBarItemTitleStepOne_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  progressBarItemTitleStepOne_not?: InputMaybe<Scalars['String']['input']>;
  progressBarItemTitleStepOne_not_contains?: InputMaybe<Scalars['String']['input']>;
  progressBarItemTitleStepOne_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  progressBarItemTitleStepThree?: InputMaybe<Scalars['String']['input']>;
  progressBarItemTitleStepThree_contains?: InputMaybe<Scalars['String']['input']>;
  progressBarItemTitleStepThree_exists?: InputMaybe<Scalars['Boolean']['input']>;
  progressBarItemTitleStepThree_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  progressBarItemTitleStepThree_not?: InputMaybe<Scalars['String']['input']>;
  progressBarItemTitleStepThree_not_contains?: InputMaybe<Scalars['String']['input']>;
  progressBarItemTitleStepThree_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  progressBarItemTitleStepTwo?: InputMaybe<Scalars['String']['input']>;
  progressBarItemTitleStepTwo_contains?: InputMaybe<Scalars['String']['input']>;
  progressBarItemTitleStepTwo_exists?: InputMaybe<Scalars['Boolean']['input']>;
  progressBarItemTitleStepTwo_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  progressBarItemTitleStepTwo_not?: InputMaybe<Scalars['String']['input']>;
  progressBarItemTitleStepTwo_not_contains?: InputMaybe<Scalars['String']['input']>;
  progressBarItemTitleStepTwo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestAppointment?: InputMaybe<Scalars['String']['input']>;
  requestAppointment_contains?: InputMaybe<Scalars['String']['input']>;
  requestAppointment_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestAppointment_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestAppointment_not?: InputMaybe<Scalars['String']['input']>;
  requestAppointment_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestAppointment_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestDataProtectionLink?: InputMaybe<Scalars['String']['input']>;
  requestDataProtectionLink_contains?: InputMaybe<Scalars['String']['input']>;
  requestDataProtectionLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestDataProtectionLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestDataProtectionLink_not?: InputMaybe<Scalars['String']['input']>;
  requestDataProtectionLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestDataProtectionLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestDescription?: InputMaybe<Scalars['String']['input']>;
  requestDescriptionLabel?: InputMaybe<Scalars['String']['input']>;
  requestDescriptionLabel_contains?: InputMaybe<Scalars['String']['input']>;
  requestDescriptionLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestDescriptionLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestDescriptionLabel_not?: InputMaybe<Scalars['String']['input']>;
  requestDescriptionLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestDescriptionLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestDescription_contains?: InputMaybe<Scalars['String']['input']>;
  requestDescription_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestDescription_not?: InputMaybe<Scalars['String']['input']>;
  requestDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestEMail?: InputMaybe<Scalars['String']['input']>;
  requestEMail_contains?: InputMaybe<Scalars['String']['input']>;
  requestEMail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestEMail_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestEMail_not?: InputMaybe<Scalars['String']['input']>;
  requestEMail_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestEMail_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestFirstName?: InputMaybe<Scalars['String']['input']>;
  requestFirstName_contains?: InputMaybe<Scalars['String']['input']>;
  requestFirstName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestFirstName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestFirstName_not?: InputMaybe<Scalars['String']['input']>;
  requestFirstName_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestFirstName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestGenderFemale?: InputMaybe<Scalars['String']['input']>;
  requestGenderFemale_contains?: InputMaybe<Scalars['String']['input']>;
  requestGenderFemale_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestGenderFemale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestGenderFemale_not?: InputMaybe<Scalars['String']['input']>;
  requestGenderFemale_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestGenderFemale_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestGenderMale?: InputMaybe<Scalars['String']['input']>;
  requestGenderMale_contains?: InputMaybe<Scalars['String']['input']>;
  requestGenderMale_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestGenderMale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestGenderMale_not?: InputMaybe<Scalars['String']['input']>;
  requestGenderMale_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestGenderMale_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestGenderOther?: InputMaybe<Scalars['String']['input']>;
  requestGenderOther_contains?: InputMaybe<Scalars['String']['input']>;
  requestGenderOther_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestGenderOther_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestGenderOther_not?: InputMaybe<Scalars['String']['input']>;
  requestGenderOther_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestGenderOther_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestLastName?: InputMaybe<Scalars['String']['input']>;
  requestLastName_contains?: InputMaybe<Scalars['String']['input']>;
  requestLastName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestLastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestLastName_not?: InputMaybe<Scalars['String']['input']>;
  requestLastName_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestLastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestMethodEmail?: InputMaybe<Scalars['String']['input']>;
  requestMethodEmail_contains?: InputMaybe<Scalars['String']['input']>;
  requestMethodEmail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestMethodEmail_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestMethodEmail_not?: InputMaybe<Scalars['String']['input']>;
  requestMethodEmail_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestMethodEmail_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestMethodOfContactLabel?: InputMaybe<Scalars['String']['input']>;
  requestMethodOfContactLabel_contains?: InputMaybe<Scalars['String']['input']>;
  requestMethodOfContactLabel_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestMethodOfContactLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestMethodOfContactLabel_not?: InputMaybe<Scalars['String']['input']>;
  requestMethodOfContactLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestMethodOfContactLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestMethodPhone?: InputMaybe<Scalars['String']['input']>;
  requestMethodPhone_contains?: InputMaybe<Scalars['String']['input']>;
  requestMethodPhone_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestMethodPhone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestMethodPhone_not?: InputMaybe<Scalars['String']['input']>;
  requestMethodPhone_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestMethodPhone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestOpportunityCostConfirmation?: InputMaybe<Scalars['String']['input']>;
  requestOpportunityCostConfirmation_contains?: InputMaybe<Scalars['String']['input']>;
  requestOpportunityCostConfirmation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestOpportunityCostConfirmation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestOpportunityCostConfirmation_not?: InputMaybe<Scalars['String']['input']>;
  requestOpportunityCostConfirmation_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestOpportunityCostConfirmation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestPhone?: InputMaybe<Scalars['String']['input']>;
  requestPhone_contains?: InputMaybe<Scalars['String']['input']>;
  requestPhone_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestPhone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestPhone_not?: InputMaybe<Scalars['String']['input']>;
  requestPhone_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestPhone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestSalutation?: InputMaybe<Scalars['String']['input']>;
  requestSalutation_contains?: InputMaybe<Scalars['String']['input']>;
  requestSalutation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestSalutation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestSalutation_not?: InputMaybe<Scalars['String']['input']>;
  requestSalutation_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestSalutation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  saleSiteSelectPlaceholder?: InputMaybe<Scalars['String']['input']>;
  saleSiteSelectPlaceholder_contains?: InputMaybe<Scalars['String']['input']>;
  saleSiteSelectPlaceholder_exists?: InputMaybe<Scalars['Boolean']['input']>;
  saleSiteSelectPlaceholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  saleSiteSelectPlaceholder_not?: InputMaybe<Scalars['String']['input']>;
  saleSiteSelectPlaceholder_not_contains?: InputMaybe<Scalars['String']['input']>;
  saleSiteSelectPlaceholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  select?: InputMaybe<Scalars['String']['input']>;
  select_contains?: InputMaybe<Scalars['String']['input']>;
  select_exists?: InputMaybe<Scalars['Boolean']['input']>;
  select_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  select_not?: InputMaybe<Scalars['String']['input']>;
  select_not_contains?: InputMaybe<Scalars['String']['input']>;
  select_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitButton?: InputMaybe<Scalars['String']['input']>;
  submitButton_contains?: InputMaybe<Scalars['String']['input']>;
  submitButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  submitButton_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitButton_not?: InputMaybe<Scalars['String']['input']>;
  submitButton_not_contains?: InputMaybe<Scalars['String']['input']>;
  submitButton_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type AppointmentBookingBcLinkingCollections = {
  __typename?: 'AppointmentBookingBcLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type AppointmentBookingBcLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AppointmentBookingBcOrder {
  BcHeadlineCalendarAsc = 'bcHeadlineCalendar_ASC',
  BcHeadlineCalendarDesc = 'bcHeadlineCalendar_DESC',
  BcHeadlineConsultationChannelAsc = 'bcHeadlineConsultationChannel_ASC',
  BcHeadlineConsultationChannelDesc = 'bcHeadlineConsultationChannel_DESC',
  BcHeadlineRequestAsc = 'bcHeadlineRequest_ASC',
  BcHeadlineRequestDesc = 'bcHeadlineRequest_DESC',
  BcHeadlineTimepickerAsc = 'bcHeadlineTimepicker_ASC',
  BcHeadlineTimepickerDesc = 'bcHeadlineTimepicker_DESC',
  BcSupTitleAsc = 'bcSupTitle_ASC',
  BcSupTitleDesc = 'bcSupTitle_DESC',
  BcTitleAsc = 'bcTitle_ASC',
  BcTitleDesc = 'bcTitle_DESC',
  ConfirmationClosingAsc = 'confirmationClosing_ASC',
  ConfirmationClosingDesc = 'confirmationClosing_DESC',
  ConfirmationSubtitleAsc = 'confirmationSubtitle_ASC',
  ConfirmationSubtitleDesc = 'confirmationSubtitle_DESC',
  ConfirmationTitleAsc = 'confirmationTitle_ASC',
  ConfirmationTitleDesc = 'confirmationTitle_DESC',
  FormValidationErrorPhoneAsc = 'formValidationErrorPhone_ASC',
  FormValidationErrorPhoneDesc = 'formValidationErrorPhone_DESC',
  FormValidationErrorSpacesAsc = 'formValidationErrorSpaces_ASC',
  FormValidationErrorSpacesDesc = 'formValidationErrorSpaces_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OpportunityTypeOfficeAsc = 'opportunityTypeOffice_ASC',
  OpportunityTypeOfficeDesc = 'opportunityTypeOffice_DESC',
  OpportunityTypePhoneAsc = 'opportunityTypePhone_ASC',
  OpportunityTypePhoneDesc = 'opportunityTypePhone_DESC',
  OpportunityTypeTeamsAsc = 'opportunityTypeTeams_ASC',
  OpportunityTypeTeamsDesc = 'opportunityTypeTeams_DESC',
  ProgressBarItemTitleStepOneAsc = 'progressBarItemTitleStepOne_ASC',
  ProgressBarItemTitleStepOneDesc = 'progressBarItemTitleStepOne_DESC',
  ProgressBarItemTitleStepThreeAsc = 'progressBarItemTitleStepThree_ASC',
  ProgressBarItemTitleStepThreeDesc = 'progressBarItemTitleStepThree_DESC',
  ProgressBarItemTitleStepTwoAsc = 'progressBarItemTitleStepTwo_ASC',
  ProgressBarItemTitleStepTwoDesc = 'progressBarItemTitleStepTwo_DESC',
  RequestAppointmentAsc = 'requestAppointment_ASC',
  RequestAppointmentDesc = 'requestAppointment_DESC',
  RequestDataProtectionLinkAsc = 'requestDataProtectionLink_ASC',
  RequestDataProtectionLinkDesc = 'requestDataProtectionLink_DESC',
  RequestDescriptionLabelAsc = 'requestDescriptionLabel_ASC',
  RequestDescriptionLabelDesc = 'requestDescriptionLabel_DESC',
  RequestEMailAsc = 'requestEMail_ASC',
  RequestEMailDesc = 'requestEMail_DESC',
  RequestFirstNameAsc = 'requestFirstName_ASC',
  RequestFirstNameDesc = 'requestFirstName_DESC',
  RequestGenderFemaleAsc = 'requestGenderFemale_ASC',
  RequestGenderFemaleDesc = 'requestGenderFemale_DESC',
  RequestGenderMaleAsc = 'requestGenderMale_ASC',
  RequestGenderMaleDesc = 'requestGenderMale_DESC',
  RequestGenderOtherAsc = 'requestGenderOther_ASC',
  RequestGenderOtherDesc = 'requestGenderOther_DESC',
  RequestLastNameAsc = 'requestLastName_ASC',
  RequestLastNameDesc = 'requestLastName_DESC',
  RequestMethodEmailAsc = 'requestMethodEmail_ASC',
  RequestMethodEmailDesc = 'requestMethodEmail_DESC',
  RequestMethodOfContactLabelAsc = 'requestMethodOfContactLabel_ASC',
  RequestMethodOfContactLabelDesc = 'requestMethodOfContactLabel_DESC',
  RequestMethodPhoneAsc = 'requestMethodPhone_ASC',
  RequestMethodPhoneDesc = 'requestMethodPhone_DESC',
  RequestPhoneAsc = 'requestPhone_ASC',
  RequestPhoneDesc = 'requestPhone_DESC',
  RequestSalutationAsc = 'requestSalutation_ASC',
  RequestSalutationDesc = 'requestSalutation_DESC',
  SaleSiteSelectPlaceholderAsc = 'saleSiteSelectPlaceholder_ASC',
  SaleSiteSelectPlaceholderDesc = 'saleSiteSelectPlaceholder_DESC',
  SelectAsc = 'select_ASC',
  SelectDesc = 'select_DESC',
  SubmitButtonAsc = 'submitButton_ASC',
  SubmitButtonDesc = 'submitButton_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = {
  __typename?: 'Asset';
  contentType?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  linkedFrom?: Maybe<AssetLinkingCollections>;
  size?: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  transform?: InputMaybe<ImageTransformOptions>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AssetFilter = {
  AND?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not?: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_contains?: InputMaybe<Scalars['String']['input']>;
  description_exists?: InputMaybe<Scalars['Boolean']['input']>;
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not?: InputMaybe<Scalars['String']['input']>;
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_exists?: InputMaybe<Scalars['Boolean']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_not?: InputMaybe<Scalars['Int']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_exists?: InputMaybe<Scalars['Boolean']['input']>;
  size_gt?: InputMaybe<Scalars['Int']['input']>;
  size_gte?: InputMaybe<Scalars['Int']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_lt?: InputMaybe<Scalars['Int']['input']>;
  size_lte?: InputMaybe<Scalars['Int']['input']>;
  size_not?: InputMaybe<Scalars['Int']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url?: InputMaybe<Scalars['String']['input']>;
  url_contains?: InputMaybe<Scalars['String']['input']>;
  url_exists?: InputMaybe<Scalars['Boolean']['input']>;
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not?: InputMaybe<Scalars['String']['input']>;
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  width?: InputMaybe<Scalars['Int']['input']>;
  width_exists?: InputMaybe<Scalars['Boolean']['input']>;
  width_gt?: InputMaybe<Scalars['Int']['input']>;
  width_gte?: InputMaybe<Scalars['Int']['input']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_lt?: InputMaybe<Scalars['Int']['input']>;
  width_lte?: InputMaybe<Scalars['Int']['input']>;
  width_not?: InputMaybe<Scalars['Int']['input']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  cardCollection?: Maybe<CardCollection>;
  entryCollection?: Maybe<EntryCollection>;
};


export type AssetLinkingCollectionsCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcExpertTip) */
export type BcExpertTip = Entry & _Node & {
  __typename?: 'BcExpertTip';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  intro?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BcExpertTipLinkingCollections>;
  supTitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcExpertTip) */
export type BcExpertTipIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcExpertTip) */
export type BcExpertTipLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcExpertTip) */
export type BcExpertTipSupTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcExpertTip) */
export type BcExpertTipTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BcExpertTipCollection = {
  __typename?: 'BcExpertTipCollection';
  items: Array<Maybe<BcExpertTip>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BcExpertTipFilter = {
  AND?: InputMaybe<Array<InputMaybe<BcExpertTipFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BcExpertTipFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  intro?: InputMaybe<Scalars['String']['input']>;
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intro_not?: InputMaybe<Scalars['String']['input']>;
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supTitle?: InputMaybe<Scalars['String']['input']>;
  supTitle_contains?: InputMaybe<Scalars['String']['input']>;
  supTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  supTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supTitle_not?: InputMaybe<Scalars['String']['input']>;
  supTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  supTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BcExpertTipLinkingCollections = {
  __typename?: 'BcExpertTipLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type BcExpertTipLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BcExpertTipOrder {
  SupTitleAsc = 'supTitle_ASC',
  SupTitleDesc = 'supTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequest = Entry & _Node & {
  __typename?: 'BcOfferRequest';
  _id: Scalars['ID']['output'];
  branch?: Maybe<Scalars['String']['output']>;
  confirmationClosing?: Maybe<Scalars['String']['output']>;
  confirmationText?: Maybe<Scalars['String']['output']>;
  confirmationTitle?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  dataProtectionLink?: Maybe<Scalars['String']['output']>;
  eMail?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  formValidationErrorPhone?: Maybe<Scalars['String']['output']>;
  formValidationErrorSpaces?: Maybe<Scalars['String']['output']>;
  genderFemale?: Maybe<Scalars['String']['output']>;
  genderMale?: Maybe<Scalars['String']['output']>;
  genderOther?: Maybe<Scalars['String']['output']>;
  intro?: Maybe<Scalars['String']['output']>;
  labelText?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<BcOfferRequestLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  opportunityBudget?: Maybe<Scalars['String']['output']>;
  opportunityCostConfirmation?: Maybe<Scalars['String']['output']>;
  opportunityPax?: Maybe<Scalars['String']['output']>;
  opportunityTravelDate?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  requestOffer?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  select?: Maybe<Scalars['String']['output']>;
  submitButton?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestBranchArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestConfirmationClosingArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestConfirmationTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestConfirmationTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestDataProtectionLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestEMailArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestFirstNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestFormValidationErrorPhoneArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestFormValidationErrorSpacesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestGenderFemaleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestGenderMaleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestGenderOtherArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestLabelTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestLastNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestOpportunityBudgetArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestOpportunityCostConfirmationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestOpportunityPaxArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestOpportunityTravelDateArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestPhoneArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestRequestOfferArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestSalutationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestSelectArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/bcOfferRequest) */
export type BcOfferRequestSubmitButtonArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BcOfferRequestCollection = {
  __typename?: 'BcOfferRequestCollection';
  items: Array<Maybe<BcOfferRequest>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BcOfferRequestFilter = {
  AND?: InputMaybe<Array<InputMaybe<BcOfferRequestFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<BcOfferRequestFilter>>>;
  branch?: InputMaybe<Scalars['String']['input']>;
  branch_contains?: InputMaybe<Scalars['String']['input']>;
  branch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  branch_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branch_not?: InputMaybe<Scalars['String']['input']>;
  branch_not_contains?: InputMaybe<Scalars['String']['input']>;
  branch_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationClosing?: InputMaybe<Scalars['String']['input']>;
  confirmationClosing_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationClosing_exists?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationClosing_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationClosing_not?: InputMaybe<Scalars['String']['input']>;
  confirmationClosing_not_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationClosing_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationText?: InputMaybe<Scalars['String']['input']>;
  confirmationText_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationText_not?: InputMaybe<Scalars['String']['input']>;
  confirmationText_not_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationTitle?: InputMaybe<Scalars['String']['input']>;
  confirmationTitle_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationTitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationTitle_not?: InputMaybe<Scalars['String']['input']>;
  confirmationTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  confirmationTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  dataProtectionLink?: InputMaybe<Scalars['String']['input']>;
  dataProtectionLink_contains?: InputMaybe<Scalars['String']['input']>;
  dataProtectionLink_exists?: InputMaybe<Scalars['Boolean']['input']>;
  dataProtectionLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataProtectionLink_not?: InputMaybe<Scalars['String']['input']>;
  dataProtectionLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  dataProtectionLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eMail?: InputMaybe<Scalars['String']['input']>;
  eMail_contains?: InputMaybe<Scalars['String']['input']>;
  eMail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eMail_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eMail_not?: InputMaybe<Scalars['String']['input']>;
  eMail_not_contains?: InputMaybe<Scalars['String']['input']>;
  eMail_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_contains?: InputMaybe<Scalars['String']['input']>;
  firstName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_not?: InputMaybe<Scalars['String']['input']>;
  firstName_not_contains?: InputMaybe<Scalars['String']['input']>;
  firstName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formValidationErrorPhone?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorPhone_contains?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorPhone_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formValidationErrorPhone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formValidationErrorPhone_not?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorPhone_not_contains?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorPhone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formValidationErrorSpaces?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorSpaces_contains?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorSpaces_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formValidationErrorSpaces_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formValidationErrorSpaces_not?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorSpaces_not_contains?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorSpaces_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genderFemale?: InputMaybe<Scalars['String']['input']>;
  genderFemale_contains?: InputMaybe<Scalars['String']['input']>;
  genderFemale_exists?: InputMaybe<Scalars['Boolean']['input']>;
  genderFemale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genderFemale_not?: InputMaybe<Scalars['String']['input']>;
  genderFemale_not_contains?: InputMaybe<Scalars['String']['input']>;
  genderFemale_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genderMale?: InputMaybe<Scalars['String']['input']>;
  genderMale_contains?: InputMaybe<Scalars['String']['input']>;
  genderMale_exists?: InputMaybe<Scalars['Boolean']['input']>;
  genderMale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genderMale_not?: InputMaybe<Scalars['String']['input']>;
  genderMale_not_contains?: InputMaybe<Scalars['String']['input']>;
  genderMale_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genderOther?: InputMaybe<Scalars['String']['input']>;
  genderOther_contains?: InputMaybe<Scalars['String']['input']>;
  genderOther_exists?: InputMaybe<Scalars['Boolean']['input']>;
  genderOther_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genderOther_not?: InputMaybe<Scalars['String']['input']>;
  genderOther_not_contains?: InputMaybe<Scalars['String']['input']>;
  genderOther_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intro?: InputMaybe<Scalars['String']['input']>;
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  intro_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intro_not?: InputMaybe<Scalars['String']['input']>;
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  intro_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labelText?: InputMaybe<Scalars['String']['input']>;
  labelText_contains?: InputMaybe<Scalars['String']['input']>;
  labelText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  labelText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  labelText_not?: InputMaybe<Scalars['String']['input']>;
  labelText_not_contains?: InputMaybe<Scalars['String']['input']>;
  labelText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_contains?: InputMaybe<Scalars['String']['input']>;
  lastName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  lastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_not?: InputMaybe<Scalars['String']['input']>;
  lastName_not_contains?: InputMaybe<Scalars['String']['input']>;
  lastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityBudget?: InputMaybe<Scalars['String']['input']>;
  opportunityBudget_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityBudget_exists?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityBudget_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityBudget_not?: InputMaybe<Scalars['String']['input']>;
  opportunityBudget_not_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityBudget_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityCostConfirmation?: InputMaybe<Scalars['String']['input']>;
  opportunityCostConfirmation_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityCostConfirmation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityCostConfirmation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityCostConfirmation_not?: InputMaybe<Scalars['String']['input']>;
  opportunityCostConfirmation_not_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityCostConfirmation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityPax?: InputMaybe<Scalars['String']['input']>;
  opportunityPax_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityPax_exists?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityPax_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityPax_not?: InputMaybe<Scalars['String']['input']>;
  opportunityPax_not_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityPax_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityTravelDate?: InputMaybe<Scalars['String']['input']>;
  opportunityTravelDate_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityTravelDate_exists?: InputMaybe<Scalars['Boolean']['input']>;
  opportunityTravelDate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityTravelDate_not?: InputMaybe<Scalars['String']['input']>;
  opportunityTravelDate_not_contains?: InputMaybe<Scalars['String']['input']>;
  opportunityTravelDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_contains?: InputMaybe<Scalars['String']['input']>;
  phone_exists?: InputMaybe<Scalars['Boolean']['input']>;
  phone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone_not?: InputMaybe<Scalars['String']['input']>;
  phone_not_contains?: InputMaybe<Scalars['String']['input']>;
  phone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestOffer?: InputMaybe<Scalars['String']['input']>;
  requestOffer_contains?: InputMaybe<Scalars['String']['input']>;
  requestOffer_exists?: InputMaybe<Scalars['Boolean']['input']>;
  requestOffer_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requestOffer_not?: InputMaybe<Scalars['String']['input']>;
  requestOffer_not_contains?: InputMaybe<Scalars['String']['input']>;
  requestOffer_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  salutation_contains?: InputMaybe<Scalars['String']['input']>;
  salutation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  salutation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salutation_not?: InputMaybe<Scalars['String']['input']>;
  salutation_not_contains?: InputMaybe<Scalars['String']['input']>;
  salutation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  select?: InputMaybe<Scalars['String']['input']>;
  select_contains?: InputMaybe<Scalars['String']['input']>;
  select_exists?: InputMaybe<Scalars['Boolean']['input']>;
  select_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  select_not?: InputMaybe<Scalars['String']['input']>;
  select_not_contains?: InputMaybe<Scalars['String']['input']>;
  select_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitButton?: InputMaybe<Scalars['String']['input']>;
  submitButton_contains?: InputMaybe<Scalars['String']['input']>;
  submitButton_exists?: InputMaybe<Scalars['Boolean']['input']>;
  submitButton_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submitButton_not?: InputMaybe<Scalars['String']['input']>;
  submitButton_not_contains?: InputMaybe<Scalars['String']['input']>;
  submitButton_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type BcOfferRequestLinkingCollections = {
  __typename?: 'BcOfferRequestLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type BcOfferRequestLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BcOfferRequestOrder {
  BranchAsc = 'branch_ASC',
  BranchDesc = 'branch_DESC',
  ConfirmationClosingAsc = 'confirmationClosing_ASC',
  ConfirmationClosingDesc = 'confirmationClosing_DESC',
  ConfirmationTitleAsc = 'confirmationTitle_ASC',
  ConfirmationTitleDesc = 'confirmationTitle_DESC',
  DataProtectionLinkAsc = 'dataProtectionLink_ASC',
  DataProtectionLinkDesc = 'dataProtectionLink_DESC',
  EMailAsc = 'eMail_ASC',
  EMailDesc = 'eMail_DESC',
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  FormValidationErrorPhoneAsc = 'formValidationErrorPhone_ASC',
  FormValidationErrorPhoneDesc = 'formValidationErrorPhone_DESC',
  FormValidationErrorSpacesAsc = 'formValidationErrorSpaces_ASC',
  FormValidationErrorSpacesDesc = 'formValidationErrorSpaces_DESC',
  GenderFemaleAsc = 'genderFemale_ASC',
  GenderFemaleDesc = 'genderFemale_DESC',
  GenderMaleAsc = 'genderMale_ASC',
  GenderMaleDesc = 'genderMale_DESC',
  GenderOtherAsc = 'genderOther_ASC',
  GenderOtherDesc = 'genderOther_DESC',
  LabelTextAsc = 'labelText_ASC',
  LabelTextDesc = 'labelText_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  OpportunityBudgetAsc = 'opportunityBudget_ASC',
  OpportunityBudgetDesc = 'opportunityBudget_DESC',
  OpportunityPaxAsc = 'opportunityPax_ASC',
  OpportunityPaxDesc = 'opportunityPax_DESC',
  OpportunityTravelDateAsc = 'opportunityTravelDate_ASC',
  OpportunityTravelDateDesc = 'opportunityTravelDate_DESC',
  PhoneAsc = 'phone_ASC',
  PhoneDesc = 'phone_DESC',
  RequestOfferAsc = 'requestOffer_ASC',
  RequestOfferDesc = 'requestOffer_DESC',
  SalutationAsc = 'salutation_ASC',
  SalutationDesc = 'salutation_DESC',
  SelectAsc = 'select_ASC',
  SelectDesc = 'select_DESC',
  SubmitButtonAsc = 'submitButton_ASC',
  SubmitButtonDesc = 'submitButton_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Ui Element Card [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/card) */
export type Card = Entry & _Node & {
  __typename?: 'Card';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  icon?: Maybe<Asset>;
  internalName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<CardLinkingCollections>;
  sys: Sys;
  text?: Maybe<CardText>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Ui Element Card [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/card) */
export type CardIconArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Ui Element Card [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/card) */
export type CardInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Ui Element Card [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/card) */
export type CardLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Ui Element Card [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/card) */
export type CardTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Ui Element Card [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/card) */
export type CardTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CardCollection = {
  __typename?: 'CardCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CardFilter = {
  AND?: InputMaybe<Array<InputMaybe<CardFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CardFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CardLinkingCollections = {
  __typename?: 'CardLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
  uspBoxCollection?: Maybe<UspBoxCollection>;
};


export type CardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CardLinkingCollectionsUspBoxCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardLinkingCollectionsUspBoxCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CardLinkingCollectionsUspBoxCollectionOrder {
  ButtonTextAsc = 'buttonText_ASC',
  ButtonTextDesc = 'buttonText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SuptitleAsc = 'suptitle_ASC',
  SuptitleDesc = 'suptitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum CardOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type CardText = {
  __typename?: 'CardText';
  json: Scalars['JSON']['output'];
  links: CardTextLinks;
};

export type CardTextAssets = {
  __typename?: 'CardTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type CardTextEntries = {
  __typename?: 'CardTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type CardTextLinks = {
  __typename?: 'CardTextLinks';
  assets: CardTextAssets;
  entries: CardTextEntries;
  resources: CardTextResources;
};

export type CardTextResources = {
  __typename?: 'CardTextResources';
  block: Array<CardTextResourcesBlock>;
  hyperlink: Array<CardTextResourcesHyperlink>;
  inline: Array<CardTextResourcesInline>;
};

export type CardTextResourcesBlock = ResourceLink & {
  __typename?: 'CardTextResourcesBlock';
  sys: ResourceSys;
};

export type CardTextResourcesHyperlink = ResourceLink & {
  __typename?: 'CardTextResourcesHyperlink';
  sys: ResourceSys;
};

export type CardTextResourcesInline = ResourceLink & {
  __typename?: 'CardTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslations = Entry & _Node & {
  __typename?: 'CommonTranslations';
  _id: Scalars['ID']['output'];
  branch?: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  eMail?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  formValidationErrorSpaces?: Maybe<Scalars['String']['output']>;
  genderFemale?: Maybe<Scalars['String']['output']>;
  genderMale?: Maybe<Scalars['String']['output']>;
  genderUnspecified?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<CommonTranslationsLinkingCollections>;
  phone?: Maybe<Scalars['String']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  select?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslationsBranchArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslationsEMailArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslationsFirstNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslationsFormValidationErrorSpacesArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslationsGenderFemaleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslationsGenderMaleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslationsGenderUnspecifiedArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslationsLastNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslationsLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslationsPhoneArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslationsSalutationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/commonTranslations) */
export type CommonTranslationsSelectArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommonTranslationsCollection = {
  __typename?: 'CommonTranslationsCollection';
  items: Array<Maybe<CommonTranslations>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type CommonTranslationsFilter = {
  AND?: InputMaybe<Array<InputMaybe<CommonTranslationsFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CommonTranslationsFilter>>>;
  branch?: InputMaybe<Scalars['String']['input']>;
  branch_contains?: InputMaybe<Scalars['String']['input']>;
  branch_exists?: InputMaybe<Scalars['Boolean']['input']>;
  branch_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  branch_not?: InputMaybe<Scalars['String']['input']>;
  branch_not_contains?: InputMaybe<Scalars['String']['input']>;
  branch_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  eMail?: InputMaybe<Scalars['String']['input']>;
  eMail_contains?: InputMaybe<Scalars['String']['input']>;
  eMail_exists?: InputMaybe<Scalars['Boolean']['input']>;
  eMail_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eMail_not?: InputMaybe<Scalars['String']['input']>;
  eMail_not_contains?: InputMaybe<Scalars['String']['input']>;
  eMail_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstName_contains?: InputMaybe<Scalars['String']['input']>;
  firstName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName_not?: InputMaybe<Scalars['String']['input']>;
  firstName_not_contains?: InputMaybe<Scalars['String']['input']>;
  firstName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formValidationErrorSpaces?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorSpaces_contains?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorSpaces_exists?: InputMaybe<Scalars['Boolean']['input']>;
  formValidationErrorSpaces_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formValidationErrorSpaces_not?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorSpaces_not_contains?: InputMaybe<Scalars['String']['input']>;
  formValidationErrorSpaces_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genderFemale?: InputMaybe<Scalars['String']['input']>;
  genderFemale_contains?: InputMaybe<Scalars['String']['input']>;
  genderFemale_exists?: InputMaybe<Scalars['Boolean']['input']>;
  genderFemale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genderFemale_not?: InputMaybe<Scalars['String']['input']>;
  genderFemale_not_contains?: InputMaybe<Scalars['String']['input']>;
  genderFemale_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genderMale?: InputMaybe<Scalars['String']['input']>;
  genderMale_contains?: InputMaybe<Scalars['String']['input']>;
  genderMale_exists?: InputMaybe<Scalars['Boolean']['input']>;
  genderMale_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genderMale_not?: InputMaybe<Scalars['String']['input']>;
  genderMale_not_contains?: InputMaybe<Scalars['String']['input']>;
  genderMale_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genderUnspecified?: InputMaybe<Scalars['String']['input']>;
  genderUnspecified_contains?: InputMaybe<Scalars['String']['input']>;
  genderUnspecified_exists?: InputMaybe<Scalars['Boolean']['input']>;
  genderUnspecified_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genderUnspecified_not?: InputMaybe<Scalars['String']['input']>;
  genderUnspecified_not_contains?: InputMaybe<Scalars['String']['input']>;
  genderUnspecified_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastName_contains?: InputMaybe<Scalars['String']['input']>;
  lastName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  lastName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName_not?: InputMaybe<Scalars['String']['input']>;
  lastName_not_contains?: InputMaybe<Scalars['String']['input']>;
  lastName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone_contains?: InputMaybe<Scalars['String']['input']>;
  phone_exists?: InputMaybe<Scalars['Boolean']['input']>;
  phone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phone_not?: InputMaybe<Scalars['String']['input']>;
  phone_not_contains?: InputMaybe<Scalars['String']['input']>;
  phone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  salutation_contains?: InputMaybe<Scalars['String']['input']>;
  salutation_exists?: InputMaybe<Scalars['Boolean']['input']>;
  salutation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  salutation_not?: InputMaybe<Scalars['String']['input']>;
  salutation_not_contains?: InputMaybe<Scalars['String']['input']>;
  salutation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  select?: InputMaybe<Scalars['String']['input']>;
  select_contains?: InputMaybe<Scalars['String']['input']>;
  select_exists?: InputMaybe<Scalars['Boolean']['input']>;
  select_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  select_not?: InputMaybe<Scalars['String']['input']>;
  select_not_contains?: InputMaybe<Scalars['String']['input']>;
  select_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type CommonTranslationsLinkingCollections = {
  __typename?: 'CommonTranslationsLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type CommonTranslationsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CommonTranslationsOrder {
  BranchAsc = 'branch_ASC',
  BranchDesc = 'branch_DESC',
  EMailAsc = 'eMail_ASC',
  EMailDesc = 'eMail_DESC',
  FirstNameAsc = 'firstName_ASC',
  FirstNameDesc = 'firstName_DESC',
  FormValidationErrorSpacesAsc = 'formValidationErrorSpaces_ASC',
  FormValidationErrorSpacesDesc = 'formValidationErrorSpaces_DESC',
  GenderFemaleAsc = 'genderFemale_ASC',
  GenderFemaleDesc = 'genderFemale_DESC',
  GenderMaleAsc = 'genderMale_ASC',
  GenderMaleDesc = 'genderMale_DESC',
  GenderUnspecifiedAsc = 'genderUnspecified_ASC',
  GenderUnspecifiedDesc = 'genderUnspecified_DESC',
  LastNameAsc = 'lastName_ASC',
  LastNameDesc = 'lastName_DESC',
  PhoneAsc = 'phone_ASC',
  PhoneDesc = 'phone_DESC',
  SalutationAsc = 'salutation_ASC',
  SalutationDesc = 'salutation_DESC',
  SelectAsc = 'select_ASC',
  SelectDesc = 'select_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  concepts: Array<Maybe<TaxonomyConcept>>;
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataConceptsFilter = {
  descendants?: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataFilter = {
  concepts?: InputMaybe<ContentfulMetadataConceptsFilter>;
  concepts_exists?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/destination) */
export type Destination = Entry & _Node & {
  __typename?: 'Destination';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  link?: Maybe<Scalars['String']['output']>;
  linkedFrom?: Maybe<DestinationLinkingCollections>;
  name?: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/destination) */
export type DestinationLinkArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/destination) */
export type DestinationLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/destination) */
export type DestinationNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DestinationCollection = {
  __typename?: 'DestinationCollection';
  items: Array<Maybe<Destination>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DestinationFilter = {
  AND?: InputMaybe<Array<InputMaybe<DestinationFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<DestinationFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  link?: InputMaybe<Scalars['String']['input']>;
  link_contains?: InputMaybe<Scalars['String']['input']>;
  link_exists?: InputMaybe<Scalars['Boolean']['input']>;
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_not?: InputMaybe<Scalars['String']['input']>;
  link_not_contains?: InputMaybe<Scalars['String']['input']>;
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_exists?: InputMaybe<Scalars['Boolean']['input']>;
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
};

export type DestinationLinkingCollections = {
  __typename?: 'DestinationLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type DestinationLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DestinationOrder {
  LinkAsc = 'link_ASC',
  LinkDesc = 'link_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EntryFilter = {
  AND?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  sys?: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageFormat {
  /** AVIF image format. */
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor?: InputMaybe<Scalars['HexColor']['input']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius?: InputMaybe<Scalars['Int']['input']>;
  /** Desired image format. Defaults to the original image format. */
  format?: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height?: InputMaybe<Scalars['Dimension']['input']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality?: InputMaybe<Scalars['Quality']['input']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus?: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy?: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width?: InputMaybe<Scalars['Dimension']['input']>;
};

export type Query = {
  __typename?: 'Query';
  _node?: Maybe<_Node>;
  _nodes: Array<Maybe<_Node>>;
  appointmentBookingBc?: Maybe<AppointmentBookingBc>;
  appointmentBookingBcCollection?: Maybe<AppointmentBookingBcCollection>;
  asset?: Maybe<Asset>;
  assetCollection?: Maybe<AssetCollection>;
  bcExpertTip?: Maybe<BcExpertTip>;
  bcExpertTipCollection?: Maybe<BcExpertTipCollection>;
  bcOfferRequest?: Maybe<BcOfferRequest>;
  bcOfferRequestCollection?: Maybe<BcOfferRequestCollection>;
  card?: Maybe<Card>;
  cardCollection?: Maybe<CardCollection>;
  commonTranslations?: Maybe<CommonTranslations>;
  commonTranslationsCollection?: Maybe<CommonTranslationsCollection>;
  destination?: Maybe<Destination>;
  destinationCollection?: Maybe<DestinationCollection>;
  entryCollection?: Maybe<EntryCollection>;
  uspBox?: Maybe<UspBox>;
  uspBoxCollection?: Maybe<UspBoxCollection>;
};


export type Query_NodeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_NodesArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppointmentBookingBcArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAppointmentBookingBcCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AppointmentBookingBcOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AppointmentBookingBcFilter>;
};


export type QueryAssetArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetFilter>;
};


export type QueryBcExpertTipArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBcExpertTipCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BcExpertTipOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BcExpertTipFilter>;
};


export type QueryBcOfferRequestArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBcOfferRequestCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<BcOfferRequestOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BcOfferRequestFilter>;
};


export type QueryCardArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CardOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CardFilter>;
};


export type QueryCommonTranslationsArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCommonTranslationsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CommonTranslationsOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CommonTranslationsFilter>;
};


export type QueryDestinationArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDestinationCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<DestinationOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DestinationFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<EntryFilter>;
};


export type QueryUspBoxArgs = {
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUspBoxCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<UspBoxOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<UspBoxFilter>;
};

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: 'ResourceSys';
  linkType: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String']['output'];
  firstPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** The locale that was requested. */
  locale?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedVersion?: Maybe<Scalars['Int']['output']>;
  spaceId: Scalars['String']['output'];
};

export type SysFilter = {
  firstPublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstPublishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstPublishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_contains?: InputMaybe<Scalars['String']['input']>;
  id_exists?: InputMaybe<Scalars['Boolean']['input']>;
  id_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not?: InputMaybe<Scalars['String']['input']>;
  id_not_contains?: InputMaybe<Scalars['String']['input']>;
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedVersion?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_exists?: InputMaybe<Scalars['Boolean']['input']>;
  publishedVersion_gt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_gte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedVersion_lt?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_lte?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not?: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename?: 'TaxonomyConcept';
  id?: Maybe<Scalars['String']['output']>;
};

export type TimelineFilterInput = {
  /** Preview content starting from a given release date */
  release_lte?: InputMaybe<Scalars['String']['input']>;
  /** Preview content starting from a given timestamp */
  timestamp_lte?: InputMaybe<Scalars['DateTime']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/uspBox) */
export type UspBox = Entry & _Node & {
  __typename?: 'UspBox';
  _id: Scalars['ID']['output'];
  buttonText?: Maybe<Scalars['String']['output']>;
  cardsCollection?: Maybe<UspBoxCardsCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalName?: Maybe<Scalars['String']['output']>;
  intro?: Maybe<UspBoxIntro>;
  linkedFrom?: Maybe<UspBoxLinkingCollections>;
  suptitle?: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title?: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/uspBox) */
export type UspBoxButtonTextArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/uspBox) */
export type UspBoxCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<UspBoxCardsCollectionOrder>>>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/uspBox) */
export type UspBoxInternalNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/uspBox) */
export type UspBoxIntroArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/uspBox) */
export type UspBoxLinkedFromArgs = {
  allowedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/uspBox) */
export type UspBoxSuptitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/z22qpbpjacj0/content_types/uspBox) */
export type UspBoxTitleArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UspBoxCardsCollection = {
  __typename?: 'UspBoxCardsCollection';
  items: Array<Maybe<Card>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum UspBoxCardsCollectionOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type UspBoxCollection = {
  __typename?: 'UspBoxCollection';
  items: Array<Maybe<UspBox>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type UspBoxFilter = {
  AND?: InputMaybe<Array<InputMaybe<UspBoxFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<UspBoxFilter>>>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_exists?: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cards?: InputMaybe<CfCardNestedFilter>;
  cardsCollection_exists?: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  intro_contains?: InputMaybe<Scalars['String']['input']>;
  intro_exists?: InputMaybe<Scalars['Boolean']['input']>;
  intro_not_contains?: InputMaybe<Scalars['String']['input']>;
  suptitle?: InputMaybe<Scalars['String']['input']>;
  suptitle_contains?: InputMaybe<Scalars['String']['input']>;
  suptitle_exists?: InputMaybe<Scalars['Boolean']['input']>;
  suptitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suptitle_not?: InputMaybe<Scalars['String']['input']>;
  suptitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  suptitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UspBoxIntro = {
  __typename?: 'UspBoxIntro';
  json: Scalars['JSON']['output'];
  links: UspBoxIntroLinks;
};

export type UspBoxIntroAssets = {
  __typename?: 'UspBoxIntroAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type UspBoxIntroEntries = {
  __typename?: 'UspBoxIntroEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type UspBoxIntroLinks = {
  __typename?: 'UspBoxIntroLinks';
  assets: UspBoxIntroAssets;
  entries: UspBoxIntroEntries;
  resources: UspBoxIntroResources;
};

export type UspBoxIntroResources = {
  __typename?: 'UspBoxIntroResources';
  block: Array<UspBoxIntroResourcesBlock>;
  hyperlink: Array<UspBoxIntroResourcesHyperlink>;
  inline: Array<UspBoxIntroResourcesInline>;
};

export type UspBoxIntroResourcesBlock = ResourceLink & {
  __typename?: 'UspBoxIntroResourcesBlock';
  sys: ResourceSys;
};

export type UspBoxIntroResourcesHyperlink = ResourceLink & {
  __typename?: 'UspBoxIntroResourcesHyperlink';
  sys: ResourceSys;
};

export type UspBoxIntroResourcesInline = ResourceLink & {
  __typename?: 'UspBoxIntroResourcesInline';
  sys: ResourceSys;
};

export type UspBoxLinkingCollections = {
  __typename?: 'UspBoxLinkingCollections';
  entryCollection?: Maybe<EntryCollection>;
};


export type UspBoxLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum UspBoxOrder {
  ButtonTextAsc = 'buttonText_ASC',
  ButtonTextDesc = 'buttonText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SuptitleAsc = 'suptitle_ASC',
  SuptitleDesc = 'suptitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type _Node = {
  _id: Scalars['ID']['output'];
};

export type CfCardNestedFilter = {
  AND?: InputMaybe<Array<InputMaybe<CfCardNestedFilter>>>;
  OR?: InputMaybe<Array<InputMaybe<CfCardNestedFilter>>>;
  contentfulMetadata?: InputMaybe<ContentfulMetadataFilter>;
  icon_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  internalName_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_exists?: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not?: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  internalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys?: InputMaybe<SysFilter>;
  text_contains?: InputMaybe<Scalars['String']['input']>;
  text_exists?: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_exists?: InputMaybe<Scalars['Boolean']['input']>;
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OfferFormQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
}>;


export type OfferFormQuery = { __typename?: 'Query', bcOfferRequestCollection?: { __typename?: 'BcOfferRequestCollection', items: Array<{ __typename?: 'BcOfferRequest', requestOffer?: string | null, intro?: string | null, labelText?: string | null, dataProtectionLink?: string | null, confirmationTitle?: string | null, confirmationText?: string | null, confirmationClosing?: string | null, submitButton?: string | null, salutation?: string | null, genderFemale?: string | null, genderMale?: string | null, genderOther?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, eMail?: string | null, branch?: string | null, select?: string | null, opportunityPax?: string | null, opportunityTravelDate?: string | null, opportunityBudget?: string | null, opportunityCostConfirmation?: string | null, formValidationErrorSpaces?: string | null, formValidationErrorPhone?: string | null } | null> } | null };

export type UspBoxQueryVariables = Exact<{
  entryId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type UspBoxQuery = { __typename?: 'Query', uspBox?: { __typename?: 'UspBox', suptitle?: string | null, title?: string | null, buttonText?: string | null, intro?: { __typename?: 'UspBoxIntro', json: any } | null, cardsCollection?: { __typename?: 'UspBoxCardsCollection', items: Array<{ __typename?: 'Card', title?: string | null, text?: { __typename?: 'CardText', json: any } | null, icon?: { __typename?: 'Asset', url?: string | null } | null } | null> } | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const OfferFormDocument = new TypedDocumentString(`
    query OfferForm($locale: String!, $tenant: String!) {
  bcOfferRequestCollection(
    locale: $locale
    where: {OR: [{contentfulMetadata: {tags_exists: true, tags: {id_contains_all: [$tenant]}}}, {contentfulMetadata: {tags_exists: true, tags: {id_contains_all: ["tenant-kuoni"]}}}]}
    order: [sys_firstPublishedAt_DESC]
  ) {
    items {
      requestOffer
      intro
      labelText
      dataProtectionLink
      confirmationTitle
      confirmationText
      confirmationClosing
      submitButton
      salutation
      genderFemale
      genderMale
      genderOther
      firstName
      lastName
      phone
      eMail
      branch
      select
      opportunityPax
      opportunityTravelDate
      opportunityBudget
      opportunityCostConfirmation
      formValidationErrorSpaces
      formValidationErrorPhone
    }
  }
}
    `) as unknown as TypedDocumentString<OfferFormQuery, OfferFormQueryVariables>;
export const UspBoxDocument = new TypedDocumentString(`
    query UspBox($entryId: String!, $locale: String!) {
  uspBox(id: $entryId, locale: $locale) {
    suptitle
    title
    intro {
      json
    }
    buttonText
    cardsCollection {
      items {
        title
        text {
          json
        }
        icon {
          url
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<UspBoxQuery, UspBoxQueryVariables>;

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOfferFormQuery(
 *   ({ query, variables }) => {
 *     const { locale, tenant } = variables;
 *     return HttpResponse.json({
 *       data: { bcOfferRequestCollection }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOfferFormQuery = (resolver: GraphQLResponseResolver<OfferFormQuery, OfferFormQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<OfferFormQuery, OfferFormQueryVariables>(
    'OfferForm',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUspBoxQuery(
 *   ({ query, variables }) => {
 *     const { entryId, locale } = variables;
 *     return HttpResponse.json({
 *       data: { uspBox }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUspBoxQuery = (resolver: GraphQLResponseResolver<UspBoxQuery, UspBoxQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<UspBoxQuery, UspBoxQueryVariables>(
    'UspBox',
    resolver,
    options
  )
